var map = {
	"./bg.svg": "819f",
	"./diarybook.svg": "1d42",
	"./empty.svg": "6ba0",
	"./shuoshuo_book.svg": "57d2",
	"./wbbook.svg": "447a",
	"./wxbook.svg": "53ae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a2d1";